import type { BuildInfo } from '../../application/dto/BuildInfo';

/**
 * Reads the build-time constants injected by vite.config.ts (`define`). Every value is computed
 * once, at build time, from package.json and git — never hand-written or updated manually.
 */
export function getBuildInfo(): BuildInfo {
  return {
    appVersion: __APP_VERSION__,
    gitCommit: __GIT_COMMIT__,
    gitBranch: __GIT_BRANCH__,
    buildDate: __BUILD_DATE__,
    environment: __BUILD_ENV__,
  };
}
